import {
  ADMIN_MEMBERS_OPTIONS,
  ADMIN_PATIENT_ID_OPTIONS,
  ADMIN_PATIENT_OPTIONS,
  ADMIN_PRACTICE_ID_OPTIONS,
  ADMIN_PRACTICE_OPTIONS,
  ADMIN_TRANSACTION_ID_OPTIONS
} from 'components/shared/Filters/lib/filterOptions';

export const DEFAULT_FILTERS = {
  date: {
    type: 'date-range',
    title: 'Date',
    icon: 'clock-mono'
  },
  id: ADMIN_TRANSACTION_ID_OPTIONS,
  practice_id: ADMIN_PRACTICE_ID_OPTIONS,
  practice_name: { ...ADMIN_PRACTICE_OPTIONS, title: 'Practice name' },
  patient_id: ADMIN_PATIENT_ID_OPTIONS,
  patient_name: { ...ADMIN_PATIENT_OPTIONS, title: 'Patient name' },
  amount: {
    type: 'range',
    title: 'Transaction amount',
    icon: 'dollar-square-mono'
  },
  cashier: {
    ...ADMIN_MEMBERS_OPTIONS,
    title: 'Cashier',
    placeholder: 'Search cashier',
    allowed_operators: ['is', 'is not', 'is any of']
  },
  card_number: {
    title: 'Credit card number',
    placeholder: 'Search by credit card number',
    allowed_operators: ['contains', 'does not contain'],
    icon: 'credit-card-mono'
  },
  type: {
    title: 'Type',
    multiple: true,
    queryFn: (_, data) => {
      const searchTerm = data.filters.searchTerm || '';
      return {
        options: [
          {
            label: 'Card present',
            value: 'CARD_PRESENT'
          },
          {
            label: 'Kiosk card present',
            value: 'KIOSK_CARD_PRESENT'
          },
          {
            label: 'Card on file',
            value: 'COF'
          },
          {
            label: 'Online',
            value: 'ONLINE'
          },
          {
            label: 'ACH',
            value: 'BANK_TRANSFER'
          },
          {
            label: 'Cash',
            value: 'cash'
          },
          {
            label: 'Check',
            value: 'check'
          },
          {
            label: 'Outside financing',
            value: 'care_credit'
          },
          {
            label: 'In progress',
            value: 'IN_PROGRESS'
          }
        ].filter((status) => status.label.toLowerCase().includes(searchTerm.toLowerCase()))
      };
    },
    queryKey: 'transaction_types.options',
    icon: 'status-mono',
    allowed_operators: ['is any of', 'is not', 'is']
  },
  status: {
    title: 'Status',
    multiple: true,
    queryFn: (_, data) => {
      const searchTerm = data.filters.searchTerm || '';
      return {
        options: [
          { label: 'Started', value: 'started' },
          { label: 'Canceled', value: 'cancelled' },
          { label: 'Completed', value: 'completed' },
          { label: 'Initiated', value: 'initiated' },
          { label: 'Voided', value: 'voided' },
          { label: 'Failed', value: 'failed' }
        ].filter((status) => status.label.toLowerCase().includes(searchTerm.toLowerCase()))
      };
    },
    queryKey: 'transaction_status.options',
    icon: 'status-mono',
    allowed_operators: ['is any of', 'is not', 'is']
  }
};
